const SET_CPS_SUBJECT = "SET_CPS_SUBJECT";
const SET_ADAPTIVE_CPS_ID = "SET_ADAPTIVE_CPS_ID";

const actionTypes = {
  SET_CPS_SUBJECT,
  SET_ADAPTIVE_CPS_ID,
};

export default actionTypes;
